import { Component, inject, OnInit, signal } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { ModalService } from '@card-software/library';
import { MaintenanceWorkOrder } from '../../models/maintenance-work-order/maintenance-work-order';
import { MaintenanceWorkOrderProxyService } from '../../proxies/maintenance-work-order.proxy.service';
import { MaintenanceWorkOrderStatusEnum } from '../../models/enum/maintenance-work-order-status.enum';
import { MaintenanceReportsFormModalComponent } from '../_modals/maintenance-reports-form-modal/maintenance-reports-form-modal.component';

@Component({
  selector: 'app-maintenance-reports',
  templateUrl: './maintenance-reports.component.html',
  styleUrl: './maintenance-reports.component.scss',
})
export class MaintenanceReportsComponent implements OnInit {
  readonly maintenanceWorkOrderProxy = inject(MaintenanceWorkOrderProxyService);
  readonly modalService = inject(ModalService);
  readonly MaintenanceWorkOrderStatusEnum = MaintenanceWorkOrderStatusEnum;

  isLoading = signal(0);
  maintenanceReports = signal<MaintenanceWorkOrder[]>([]);

  ngOnInit() {
    this.startLoading();
    this.getDataTable();
  }

  getDataTable() {
    this.maintenanceWorkOrderProxy
      .getAll()
      .pipe(finalize(() => this.stopLoading()))
      .subscribe({
        next: (response) => {
          if (response.data) {
            this.maintenanceReports.set(response.data);
          }
        },
      });
  }

  openEmitTicketModal(report?: MaintenanceWorkOrder) {
    this.modalService
      .open(
        MaintenanceReportsFormModalComponent,
        {},
        {
          report: report ? report : null,
        },
      )
      .subscribe((result) => {
        if (result?.action === 'save') {
          this.getDataTable();
        }
      });
  }

  startLoading() {
    this.isLoading.set(this.isLoading() + 1);
  }

  stopLoading() {
    this.isLoading.set(Math.max(0, this.isLoading() - 1));
  }

  getStatusName(status: number): string {
    return MaintenanceWorkOrderStatusEnum[status];
  }
}
